var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdd !== '')?_c('div',{staticClass:"books",on:{"click":_vm.addBookrack}},[(!_vm.isAdd)?_c('img',{attrs:{"src":"https://img01.yzcdn.cn/upload_files/2021/08/04/FswDTjy00O5Q0P8i5D0LKdGOuVI4.png"}}):_vm._e(),(_vm.isAdd)?_c('img',{attrs:{"src":"https://img01.yzcdn.cn/upload_files/2021/08/04/FmGErFGGoX7XYh66yoEAuFOhvkgA.png"}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }